import {
  Button,
  Divider,
  Link as MuiLink,
  Popover,
  Stack,
  Typography,
  styled,
  useTheme,
} from "@mui/material"
import { useSsoService } from "@pharmupp/p3-front-commons"
import type { PropsWithChildren } from "react"
import { Power } from "react-feather"
import { Link } from "react-router-dom"
import type { UserMenuProps } from "./userMenu.model"

const ICON_SIZE = "20px"

export const UserMenuLayout = ({
  items = [],
  children,
  ...props
}: PropsWithChildren<UserMenuProps>) => {
  const theme = useTheme()
  const sso = useSsoService()

  const logoutItem: (typeof items)[number] = {
    Icon: Power,
    iconColor: theme.palette.red.main,
    label: "Déconnexion",
    onClick: sso.logout,
  }
  return (
    <Popover
      slotProps={{
        paper: {
          style: { width: "360px" },
        },
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: -10,
        horizontal: "right",
      }}
      {...props}
    >
      <Stack divider={<Divider />}>
        {children}
        {[...items, logoutItem]
          .filter((item) => !item.hidden)
          .map((item) => (
            <LinkContainer
              key={item.label}
              onClick={() => props.onClose()}
              {...("to" in item
                ? {
                    to: item.to,
                    component: Link,
                  }
                : "href" in item
                  ? {
                      href: item.href,
                      component: MuiLink,
                      target: item.target ?? "_blank",
                    }
                  : {
                      onClick: () => {
                        item.onClick()
                        props.onClose()
                      },
                      component: item.component ?? MuiLink,
                    })}
            >
              <item.Icon color={item.iconColor} size={ICON_SIZE} />
              <LinkLabel>{item.label}</LinkLabel>
            </LinkContainer>
          ))}
      </Stack>
    </Popover>
  )
}

export const LinkContainer = styled(Button)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
  gap: `${theme.spacing(2)}`,
  borderRadius: 0,
  justifyContent: "flex-start",
}))

const LinkLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark1,
  fontWeight: 500,
}))
